module.exports = __webpack_public_path__ + "img/accueil-entete-paysage.dd2c6efe.jpg";